import React from "react";
import { TextField as MuiTextField, } from "@material-ui/core";
export const TextField = props => (React.createElement(MuiTextField, { variant: "filled", ...props, InputProps: { disableUnderline: true, ...(props.InputProps || {}) } }));
